import h from "./bus.es.js";
import "./waterfall.vue.es2.js";
import d from "./_virtual/_plugin-vue2_normalizer.es.js";
const f = {
  props: {
    col: {
      type: Number,
      default: 2
    },
    width: Number,
    height: {
      type: String
      // default:'100vh',    取消height默认值
    },
    data: {
      type: Array,
      default: []
    },
    gutterWidth: {
      type: Number,
      default: 10
    },
    isTransition: {
      type: Boolean,
      default: !0
    },
    lazyDistance: {
      type: Number,
      default: 300
    },
    loadDistance: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      root: null,
      columns: [],
      loadmore: !0,
      timeout: null,
      lazyTimeout: null,
      lastScrollTop: 0,
      timer: null,
      loadedIndex: 0,
      columnWidth: 0,
      isresizing: !1,
      asyncTasks: [],
      clientHeight: document.documentElement.clientHeight || document.body.clientHeight,
      clientWidth: document.documentElement.clientWidth || document.body.clientWidth
    };
  },
  computed: {
    trueLazyDistance() {
      return this.clientWidth / 375 * this.lazyDistance;
    },
    max() {
      return this.clientWidth / 375 * this.loadDistance;
    },
    viewHeight() {
      return this.height ? this.root.offsetHeight : this.clientHeight;
    }
  },
  watch: {
    col(t) {
      this.$nextTick(() => {
        this.init();
      });
    },
    data(t, e) {
      this.$nextTick(() => {
        const i = this;
        function s(l) {
          if (i.isresizing && l) {
            i.asyncTasks.push(l);
            return;
          }
          i.asyncTasks.length ? (i.asyncTasks.shift()(), l && i.asyncTasks.push(l)) : l && l();
        }
        s(async () => {
          t.length < this.loadedIndex && (this.loadedIndex = t.length), await this.resize(this.loadedIndex > 0 ? this.loadedIndex : null), s();
        });
      });
    }
  },
  methods: {
    init() {
      this.root = this.$refs.vueWaterfall, this.clearColumn();
      for (var t = parseInt(this.col), e = 0; e < t; e++) {
        let i = document.createElement("div");
        if (i.className = "vue-waterfall-column", this.width)
          i.style.width = this.width + "px", e != 0 && (i.style.marginLeft = this.gutterWidth + "px"), this.columnWidth = this.width;
        else if (this.gutterWidth && !this.width) {
          const s = Math.floor(
            (this.root.offsetWidth - (t - 1) * this.gutterWidth) / t
          );
          e != 0 && (i.style.marginLeft = this.gutterWidth + "px"), i.style.width = s + "px", this.columnWidth = s;
        } else
          i.style.width = 100 / parseInt(t) + "%", this.columnWidth = 100 / parseInt(t) / 100 * document.documentElement.clientWidth;
        this.root || (this.root = this.$refs.vueWaterfall), this.root && this.root.appendChild(i), this.columns.push(i);
      }
      this.resize();
    },
    async __setDomImageHeight(t) {
      if (t.getElementsByTagName)
        for (var e = t.getElementsByTagName("img"), i = 0; i < e.length; i++) {
          var s = e[i].getAttribute("lazy-src");
          if (!e[i].getAttribute("src") && s) {
            var o = new Image();
            if (o.src = s, o.complete) {
              var l = e[i].offsetWidth || this.columnWidth, r = o.height * l / o.width;
              l && (e[i].style.height = r + "px");
            } else
              await new Promise((a, c) => {
                o.onload = function() {
                  var n = e[i].offsetWidth || this.columnWidth, u = o.height * n / o.width;
                  n && (e[i].style.height = u + "px"), a();
                }, o.onerror = function() {
                  a();
                };
              });
          }
        }
    },
    async append(t) {
      var e = this;
      if (this.columns.length > 0) {
        let s = this.columns[0];
        for (var i = 1; i < this.columns.length; i++)
          await e.__getHeight(s) > await e.__getHeight(e.columns[i]) && (s = e.columns[i]);
        await this.__setDomImageHeight(t), s && s.appendChild(t);
      }
    },
    checkImg(t) {
      return t ? !!(t.getElementsByTagName && t.getElementsByTagName("img").length) : !1;
    },
    async resize(t, e) {
      this.isresizing = !0, this.routeChanged = !1;
      var i = this;
      if (!this.$slots.default) {
        this.isresizing = !1;
        return;
      }
      !t && t != 0 && !e ? (e = this.$slots.default, this.loadedIndex = 0, this.clear()) : e || (this.loadedIndex = t, e = this.$slots.default.splice(t));
      for (var s = 0; s < e.length; s++) {
        if (this.routeChanged) {
          console.warn("路由发生变化，<vue-waterfall>组件停止渲染");
          break;
        }
        if (e[s].elm && i.checkImg(e[s].elm)) {
          var o = e[s].elm.getElementsByTagName("img"), l = new Image();
          l.src = o[0].getAttribute("src") || o[0].getAttribute("lazy-src"), l.complete ? (await i.append(e[s].elm), i.lazyLoad(o)) : await new Promise((r, a) => {
            l.onload = async function() {
              await i.append(e[s].elm), i.lazyLoad(o), r();
            }, l.onerror = async function(c) {
              await i.append(e[s].elm), i.lazyLoad(o), r();
            };
          });
        } else
          await i.append(e[s].elm);
        i.loadedIndex++;
      }
      this.isresizing = !1, i.$emit("finish");
    },
    computedPx(t, e) {
      t.style.width = e.width / this.columnWidth;
    },
    lazyLoad(t) {
      if (t || (this.root || (this.root = this.$refs.vueWaterfall), t = this.root && this.root.getElementsByTagName("img")), !(!t || t.length < 0))
        for (var e = 0; e < t.length; e++)
          t[e].className.match("animation") && t[e].getAttribute("src") || (t[e].className.match("animation") && !t[e].getAttribute("src") ? (t[e].src = t[e].getAttribute("lazy-src"), t[e].removeAttribute("lazy-src")) : t[e].getAttribute("src") && !t[e].className.match("animation") ? t[e].className = t[e].className + " animation" : !t[e].getAttribute("src") && t[e].getBoundingClientRect().top < this.viewHeight + this.trueLazyDistance && (t[e].src = t[e].getAttribute("lazy-src"), t[e].className = t[e].className + " animation", t[e].removeAttribute("lazy-src")));
    },
    clearColumn() {
      this.columns.forEach((t) => {
        t.remove();
      }), this.columns = [];
    },
    clear() {
      this.columns.forEach((t) => {
        t.innerHTML = "";
      });
    },
    mix() {
      var t = this.$slots.default;
      console.log("elements", t), t.sort(() => Math.random() - 0.5), this.resize(0, t);
    },
    async __getHeight(t) {
      return t.offsetHeight;
    },
    __emitLoadMore() {
      if (!this.root)
        return;
      var t = this;
      const e = this.height ? this.root.scrollTop : document.documentElement.scrollTop || document.body.scrollTop, i = this.height ? this.root.scrollHeight : document.documentElement.offsetHeight;
      var s = i - e - this.viewHeight;
      t.$emit("scroll", {
        scrollHeight: i,
        scrollTop: e,
        viewHeight: this.viewHeight,
        clientHeight: t.clientHeight,
        diff: s,
        time: Date.now()
      }), s < t.max && t.loadmore && i > this.viewHeight ? (t.lastScrollTop = e, t.loadmore = !1, t.$emit("loadmore")) : s >= t.max && (t.loadmore = !0), clearTimeout(t.lazyTimeout), t.lazyTimeout = setTimeout(function() {
        t.lazyLoad();
      }, 14);
    },
    handleScroll() {
      this.__emitLoadMore();
    },
    initScrollEvents() {
      this.height ? (this.root.addEventListener("scroll", this.handleScroll), this.root.addEventListener("touchmove", this.handleScroll)) : (document.addEventListener("scroll", this.handleScroll), document.addEventListener("touchmove", this.handleScroll));
    },
    destoryScrollEvents() {
      this.root && this.root.removeEventListener("scroll", this.handleScroll), this.root && this.root.removeEventListener("touchmove", this.handleScroll), this.root && (this.root.onresize = null), window.onresize = null, document.removeEventListener("scroll", this.handleScroll), document.removeEventListener("touchmove", this.handleScroll);
    },
    // 监听路由是否发生变化
    __listenRouterChange() {
      var t = function(i) {
        var s = history[i];
        return function() {
          var o = s.apply(this, arguments), l = new Event(i);
          return l.arguments = arguments, window.dispatchEvent(l), o;
        };
      };
      ["replaceState", "pushState"].forEach((i) => {
        window.addEventListener(i, () => {
          this.routeChanged = !0;
        }), window.history[i] = t(i);
      }), window.addEventListener("popstate", () => {
        this.routeChanged = !0;
      });
    }
  },
  destroyed() {
    this.destoryScrollEvents();
  },
  unmounted() {
    this.destoryScrollEvents();
  },
  beforeCreate() {
    h.on("forceUpdate", () => {
      this.resize();
    }), h.on("mix", () => {
      this.mix();
    });
  },
  mounted() {
    this.__listenRouterChange(), this.$nextTick(() => {
      this.init(), this.initScrollEvents();
    });
  },
  activated() {
    this.initScrollEvents();
  },
  deactivated() {
    this.destoryScrollEvents();
  }
};
var m = function() {
  var e = this, i = e._self._c;
  return i("div", { ref: "vueWaterfall", staticClass: "vue-waterfall", class: e.isTransition && "is-transition", style: { height: e.height }, attrs: { id: "vueWaterfall" } }, [i("div", { staticClass: "slot-box" }, [e._t("default")], 2)]);
}, v = [], g = /* @__PURE__ */ d(
  f,
  m,
  v,
  !1,
  null,
  null,
  null,
  null
);
const E = g.exports;
export {
  E as default
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-waterfall2/dist/waterfall.vue.es.js
// module id = null
// module chunks = 